import { Box, Stack, Typography } from '@mui/material';
import logo from '../assets/images/JOB1.png';

/** Retain the original brand mark with a readable, shared wordmark. */
export default function BrandLockup({ light = false }: { light?: boolean }) {
  return (
    <Stack direction="row" alignItems="center" spacing={0.5}>
      <Box component="img" src={logo} alt="" sx={{ width: 48, height: 48, flexShrink: 0 }} />
      <Typography component="span" sx={{ fontFamily: 'Epilogue, sans-serif', fontWeight: 800, fontSize: 21, letterSpacing: '-0.9px', color: light ? '#fff' : 'text.primary', whiteSpace: 'nowrap' }}>
        Job<Box component="span" sx={{ color: light ? '#fff' : 'text.primary' }}>Victory</Box>
        <Box component="span" sx={{ color: 'primary.main' }}>.</Box>
      </Typography>
    </Stack>
  );
}
